import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFacebook = function SvgFacebook(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#1877F2",
        d: "M120 60.002c0 30.304-22.463 55.357-51.644 59.422a60.9 60.9 0 0 1-17.965-.189C21.82 114.635 0 89.865 0 60.002 0 26.865 26.865 0 59.998 0S120 26.865 120 60.002"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M68.356 48.176v13.07h16.169l-2.56 17.608h-13.61v40.566a60.9 60.9 0 0 1-17.964-.189V78.854H35.48V61.247h14.912V45.254c0-9.922 8.043-17.969 17.969-17.969v.009c.03 0 .055-.009.084-.009h16.085v15.228H74.02a5.66 5.66 0 0 0-5.66 5.659z"
    })));
};

export { SvgFacebook as ReactComponent };
//# sourceMappingURL=Facebook.svg.es.js.map
